import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import CopyableEmail from './CopyableEmail';

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.06] bg-[#050814]" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-amber-500 text-[#050814] font-black text-sm">1</div>
              <span className="text-lg font-semibold tracking-tight">
                <span className="text-amber-500 italic font-bold">1 on 1 Trade</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Professional-grade MetaTrader Expert Advisors from Hettie Nel's 20+ years of forex training excellence.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-amber-500 mb-4">Products</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/products" className="text-sm text-slate-400 hover:text-white transition-colors">Expert Advisors</Link>
              <Link to="/indicators" className="text-sm text-slate-400 hover:text-white transition-colors">Indicators</Link>
              <Link to="/all-courses" className="text-sm text-slate-400 hover:text-white transition-colors">All Courses</Link>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-amber-500 mb-4">Company</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/affiliate" className="text-sm text-slate-400 hover:text-white transition-colors">Affiliate Program</Link>
              <Link to="/reviews" className="text-sm text-slate-400 hover:text-white transition-colors">Reviews</Link>
              <Link to="/risk-disclaimer" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-risk-link">Risk Disclaimer</Link>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-amber-500 mb-4">Support</h4>
            <div className="flex flex-col gap-2.5">
              <CopyableEmail email="info@1on1trade.com" className="text-sm text-slate-400 hover:text-white transition-colors" testId="footer-email" />
              <Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact Us</Link>
              <span className="text-sm text-slate-400">4.9/5 on Forex Peace Army</span>
            </div>
          </div>
        </div>

        {/* Risk Disclosure block */}
        <div className="mt-10 rounded-xl border border-amber-500/15 bg-amber-500/[0.025] p-5 flex items-start gap-3" data-testid="footer-risk-block">
          <AlertTriangle size={18} className="text-amber-500 shrink-0 mt-0.5" />
          <p className="text-[11px] text-slate-400 leading-relaxed">
            <span className="text-amber-500 font-bold uppercase tracking-wider">Risk Warning:</span> Trading foreign exchange on margin carries a high level of risk and may not be suitable for all investors. You could lose some or all of your invested capital. Past performance is not indicative of future results. All content on this site is for educational purposes only and does not constitute financial advice. <Link to="/risk-disclaimer" className="text-amber-500 hover:text-amber-400 underline underline-offset-2 transition-colors">Read the full Risk Disclaimer</Link>.
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">Forex trading involves substantial risk. Only trade with capital you can afford to lose.</p>
          <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} 1on1trade. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
